import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';

// 1. 创建 HTTP 链路（指定 GraphQL 地址）
const httpLink = new HttpLink({
  uri: 'https://koa-workers-openai-production.gjf20001001.workers.dev/graphql',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 2. 组合链路（4.x 版本需用 from 包裹，后续可添加其他链路如错误处理链路）
const link = from([httpLink]);

// 3. 初始化 ApolloClient（必须包含 link 和 cache 属性）
const client = new ApolloClient({
  link: link, // 显式传入链路（核心修复）
  cache: new InMemoryCache(), // 缓存配置不变
});

export default client;